import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'draft-js/dist/Draft.css';

import { Button } from '@mui/material';

import { apiList } from '../../../api/callAPI';

import useColorSystem from '../../../hook/useColorSystem';

const TaboolaFieldsCustomConvertions = ({
  allOptionFields,
  setAllOptionFields,
  customDisplayFields,
  origiCustomData,
  setOrigiCustomData,
  setCurrenOptionFields,
  selectedAdAccounts,
  handleCustomData,
  fetchData
}) => {
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const handleGetCustomFields = () => {
    setOrigiCustomData([]);
    setCurrenOptionFields(null);
    fetchData(apiList.taboolaCustomFields, 'customConversions', (resData) => {
      handleCustomData(resData, 'click');
    })
  }

  useEffect(() => {
    changeCustomConvertions();
  }, [origiCustomData]);

  const changeCustomConvertions = () => {
    const cloneAllDisplayFields = JSON.parse(JSON.stringify(allOptionFields));
    const clearCustomFields = cloneAllDisplayFields.filter(el => el.name !== '自訂轉換欄');
    const addCustomConvertions = customDisplayFields.concat(clearCustomFields);

    setAllOptionFields(addCustomConvertions);
  }

  return (
    <>
      {selectedAdAccounts.length > 0 && !origiCustomData.length &&
        <Button
          variant='text-system-normal'
          onClick={handleGetCustomFields}
          sx={{ color: mainColor }}
        >
          匯入自訂欄
        </Button>
      }
    </>
  )
}

export default TaboolaFieldsCustomConvertions;